import React, { useEffect, useState } from "react";
import { Box, Button, Typography, IconButton, Input } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description"; // General file icon
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"; // PDF icon
import ArticleIcon from "@mui/icons-material/Article"; // DOC icon
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"; // Excel icon

const ViewFile = ({  filesList }) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);

  useEffect(() => {
    console.log(filesList)
    if (filesList) {
      setUploadedFiles(filesList); // Initialize with the filesList passed from the parent
    }
  }, [filesList]);

 
  const getFileIcon = (fileType) => {
    if (fileType.includes("pdf")) {
      return <PictureAsPdfIcon sx={{ color: "red", fontSize: "16px" }} />;
    }
    if (fileType.includes("docx") || fileType.includes("doc")) {
      return <ArticleIcon sx={{ color: "blue", fontSize: "14px" }} />;
    }
    if (
      fileType.includes("xlsx") ||
      fileType.includes("xls") ||
      fileType.includes("sheet")
    ) {
      return <InsertDriveFileIcon sx={{ color: "green", fontSize: "14px" }} />;
    }
    return <DescriptionIcon sx={{ color: "gray", fontSize: "16px" }} />;
  };

  const getFileName=(url)=>{
    let name=decodeURIComponent(url.split("/").pop());
    let fileName=name.split("_").pop();
    console.log(fileName,name)
    return fileName;
  }

  return (
    <Box sx={{width:"100%"}}>
      {/* <Typography>Upload evidence</Typography> */}
        {/* File Information */}
        {uploadedFiles.length>0 ?
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
            }}
          >
            {getFileIcon(uploadedFiles[0])}
            <a
              href={filesList || "#"}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "inherit",
                fontWeight: "bold",
              }}
            >
            <Typography
              sx={{
                flex: 1,
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                fontSize: "12px",
                width: "6rem",
                color: "#333",
                ml: "1px",
                borderBottom: "1px solid blue",
              }}
            >
              {getFileName(uploadedFiles[0])}
            </Typography>
</a>
               </Box>
          : <Typography
          sx={{
            flex: 1,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            fontSize: "12px",
            width: "7rem",
            color: "#333",
            ml: "1px",
          }}
        >No Files Uploaded</Typography>}
        </Box>
          );
};

export default ViewFile;